import { PropTypes } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import SubmitButton from '@atoms/SubmitButton';
import { H2 } from '@styled';
import { mediaQueries } from '@general/breakpoints';

const Column1 = styled.div`
    padding-left: 30px;
    padding-right: 30px;

    @media ${mediaQueries.md} {
        padding-left: 0;
        padding-right: 50px;
        width: 60%;
    }

    @media ${mediaQueries.lg} {
        /*  */
    }

    @media ${mediaQueries.xl} {
        padding-right: 136px;
    }
`;

const Column2 = styled.div`
    display: none;
    padding-bottom: 21px;
    padding-top: 21px;

    @media ${mediaQueries.md} {
        display: block;
    }

    img {
        height: 100%;
        max-width: 100%;
        object-fit: cover;
    }
`;

export const Unlock = ({ onNext }) => (
    <div className="d-flex">
        <Column1>
            <H2 className="mb-1.5rem">Unlock connection recommendations by adding a few details to your profile.</H2>
            <SubmitButton onClick={() => onNext({})}>Get Started Now</SubmitButton>
        </Column1>

        <Column2>
            <img src="/assets/images/progressive-profile.png" alt="Progressive Profile" />
        </Column2>
    </div>
);

Unlock.propTypes = {
    onNext: PropTypes.func,
};
